import { useState } from "react";

const Navbar = () => {
    let[data, setData] = useState("false")
    const navBar = document.getElementById("navBar");
    const navToggle = document.getElementById("navToggle");

    const hamburgerClick = () => {
        
    //let visibility = navBar.getAttribute("data-visible");
    if (data === "false"){
        //navBar.setAttribute("data-visible", "true");
        setData(data="true")
        //navToggle.setAttribute("aria-expanded", "true");
    } else if (data === "true"){
        //navBar.setAttribute("data-visible", "false");
        setData(data="false")
        //navToggle.setAttribute("aria-expanded", "false");
    };
    }

  return (
    <header className="primary-header">
        <div className="logo"><h2>EGHY</h2></div>
        <button onClick={hamburgerClick} id="navToggle" aria-controls="navBar" aria-expanded="false">
            <span>Menu</span>
        </button>
        <nav>
            <ul id="navBar" data-visible={data}>
                <li><a href=""><span>Home</span></a></li>
                <li><a href=""><span>About</span></a></li>
                <li><a href=""><span>Featured</span></a></li>
                <li><a href=""><span>Contact Me</span></a></li>
            </ul>
        </nav>
    </header>
  )
}

export default Navbar